import {useState} from 'react'
import config from 'src/config'
import KOHCard from 'src/components/kohIntegration/KOHOtpCard'
import InstitutionResource from 'src/entities/InstitutionResource'
import {transformKeys} from 'src/utils/transformKeys'

type Props = {
  onProceed: (data: InstitutionResource | null) => void
}

const KOHIntegrationPage = ({onProceed}: Props) => {
  const [showForm, setShowForm] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [otpSent, setOtpSent] = useState(false)

  const sendOtp = (institutionCode: string, contactId: string) => {
    setIsLoading(true)
    setErrorMessage(null)
    fetch(
      `${config.kohApiUrl}/UpdateForm/sendOtp?IndificationNo=${contactId}&institutionId=${institutionCode}`,
      {
        method: 'POST',
        headers: {'Content-Type': 'application/json'}
      }
    )
      .then(res => {
        if (res.status === 200) setOtpSent(true)
        else if (res.status === 404)
          setErrorMessage('הפרטים לא תואמים למידע שקיים אצלנו')
        else setErrorMessage('אירעה שגיאה, נסה שוב מאוחר יותר')
      })
      .catch(() => setErrorMessage('אירעה שגיאה, נסה שוב מאוחר יותר'))
      .finally(() => setIsLoading(false))
  }

  const getKohData = (
    institutionCode: string,
    contactId: string,
    otp: string
  ) => {
    setIsLoading(true)
    setErrorMessage(null)
    fetch(
      `${config.kohApiUrl}/UpdateForm/validateOtpForKST?IndificationNo=${contactId}&institutionId=${institutionCode}&otp=${otp}`,
      {
        method: 'POST',
        headers: {'Content-Type': 'application/json'}
      }
    )
      .then(async res => {
        if (res.status === 200) {
          const data = await res.json()
          data.externalNote = ''
          onProceed(transformKeys(data) as InstitutionResource)
        } else {
          if (res.status === 404) setErrorMessage('הסיסמה החד פעמית שגויה')
          else setErrorMessage('אירעה שגיאה, נסה שוב מאוחר יותר')
          setIsLoading(false)
        }
      })
      .catch(() => {
        setErrorMessage('אירעה שגיאה, נסה שוב מאוחר יותר')
        setIsLoading(false)
      })
  }

  const onSubmit = (
    institutionCode: string,
    contactId: string,
    otp?: string
  ) => {
    if (otpSent) {
      getKohData(institutionCode, contactId, otp ?? '')
    } else {
      sendOtp(institutionCode, contactId)
    }
  }

  if (showForm) {
    return (
      <KOHCard
        variant="login"
        onSubmit={onSubmit}
        isLoading={isLoading}
        errorMessage={errorMessage}
        otpSent={otpSent}
      />
    )
  }

  return (
    <KOHCard
      variant="question"
      onYes={() => setShowForm(true)}
      onProceed={() => onProceed(null)}
    />
  )
}

export default KOHIntegrationPage
